module.exports = __webpack_public_path__ + "img/tx-_0000s_0008_9.50ead4b0.png";